import config from '../config'
import ExecutionEnvironment from 'exenv'

const isBrowser = next => {
  if (!ExecutionEnvironment.canUseDOM) {
    return
  }

  return next()
}

export const setCookie = (name, value, days) => {
  let expires = ''

  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = `; expires="${date.toUTCString()}"`
  }

  document.cookie = `${name}=${value || ''}${expires};path=/;domain=${
    config.domain
  }`
}

export const getCookie = name => {
  const nameEQ = `${name}=`
  const cookies = decodeURIComponent(document.cookie).split(';')

  const cookie = cookies.map(c => c.trim()).find(c => c.startsWith(nameEQ))
  if (cookie) {
    return cookie.slice(nameEQ.length)
  }

  return null
}

export const removeCookie = name => {
  setCookie(name, '', -1)
}

export default {
  setCookie: (...args) => isBrowser(() => setCookie(...args)),
  getCookie: (...args) => isBrowser(() => getCookie(...args)),
  removeCookie: (...args) => isBrowser(() => removeCookie(...args))
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js